module.exports = __webpack_public_path__ + "img/print.ee557156.svg";